export interface IPagination {
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

const defaultCurrentPage = 1;
const defaultTotalCount = 0;
export const defaultPageSizes = {
    small: 10,
    large: 20,
    max: 100,
} as const;

export const defaultPagination: (args?: Partial<IPagination>) => IPagination = (
    args
) => ({
    currentPage: args?.currentPage ?? defaultCurrentPage,
    pageSize: args?.pageSize ?? defaultPageSizes.small,
    totalCount: args?.totalCount ?? defaultTotalCount,
});

export interface ISorting<T extends string = string> {
    sortBy: T;
    sortByDescending: boolean;
}

export type LoadStatus = 'idle' | 'loading' | 'failed';
